jQuery(document).ready(function($) {
    if($('.gfield.rating').length) {
        $(".gfield.rating input").click(function() {
            $(".gfield.rating .gchoice").removeClass('active');

            $(this).parent().prevAll( ".gchoice" ).addClass('active');
            $(this).parent().addClass('active');
        });
    }
});